import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import GoogleLogin from "pages/login/GoogleLogin";
import AuthCallback from "pages/login/AuthCallback";
import ProtectedRoute from "router/ProtectedRoute";
import BusinessProtectedRoute from "router/BusinessProtectedRoute";
import AdminProtectedRoute from "router/AdminProtectedRoute";
import { ChatProvider } from "providers/ChatProvider/ChatProvider";
const Nlp = React.lazy(() => import("pages/nlp/Nlp"));
const MemoryDashboard = React.lazy(() => import("pages/MemoryDashboard/MemoryDashboard"));
const ManageMessages = React.lazy(() => import("pages/ManageMessages/ManageMessages"));
const ManageBudgets = React.lazy(() => import("pages/ManageBudgets/ManageBudgets"));
const ManageAssistants = React.lazy(() => import("pages/ManageAssistants/ManageAssistants"));
const ManageTags = React.lazy(() => import("pages/ManageTags/ManageTags"));
const ManageProcessPrograms = React.lazy(() => import("pages/ManageProcessPrograms/ManageProcessPrograms"));
const AdminSettings = React.lazy(() => import("pages/AdminSettings/AdminSettings"));
const ManageTherapistsAdvisors = React.lazy(() => import("pages/ManageTherapistsAdvisors/ManageTherapistsAdvisors"));
const HKAIPlayground = React.lazy(() => import("pages/HKAIPlayground/HKAIPlayground"));
const AiFlowManager = React.lazy(() => import("pages/AiFlowManager/App"));
const MeetingSummarySearchTest = React.lazy(() => import("pages/MeetingSummarySearchTest/MeetingSummarySearchTest"));
const MeetingFeedbackSearchTest = React.lazy(() => import("pages/MeetingFeedbackSearchTest/MeetingFeedbackSearchTest"));
const KnowledgeBase = React.lazy(() => import("pages/KnowledgeBase/KnowledgeBase"));
const Workspace = React.lazy(() => import("pages/workspace/Workspace"));
const PublicBookingPage = React.lazy(() => import("pages/publicBooking/PublicBookingPage"));

export const AppRouter: React.FC = () => {
    return (
        <Routes>
            <Route path="/signin" element={<AuthCallback />} />
            <Route path="/login" element={<GoogleLogin />} />
            <Route path="/book/:token" element={<PublicBookingPage />} />
            <Route path="/" element={<Navigate to="/signin" replace />} />
            <Route element={<ProtectedRoute />}>
                <Route
                    path="/workspace/*"
                    element={
                        <ChatProvider deferBackgroundLoads>
                            <Workspace />
                        </ChatProvider>
                    }
                />
                <Route path="/nlp" element={<Nlp />} />
                <Route path="/memory" element={<MemoryDashboard />} />
                <Route
                    path="/hk-ai-playground"
                    element={
                        <BusinessProtectedRoute requireSuperAdminForUserAccounts>
                            <HKAIPlayground />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/manage-messages"
                    element={
                        <BusinessProtectedRoute requireSuperAdminForUserAccounts>
                            <ManageMessages />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/manage-budgets"
                    element={
                        <BusinessProtectedRoute requireSuperAdminForUserAccounts>
                            <ManageBudgets />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/manage-assistants"
                    element={
                        <BusinessProtectedRoute requireSuperAdminForUserAccounts>
                            <ManageAssistants />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/manage-process-programs"
                    element={
                        <BusinessProtectedRoute>
                            <ChatProvider>
                                <ManageProcessPrograms />
                            </ChatProvider>
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/admin-settings"
                    element={
                        <ChatProvider>
                            <AdminSettings />
                        </ChatProvider>
                    }
                />
                <Route
                    path="/admin-settings/:section"
                    element={
                        <ChatProvider>
                            <AdminSettings />
                        </ChatProvider>
                    }
                />
                <Route
                    path="/admin-settings/:section/:tab"
                    element={
                        <ChatProvider>
                            <AdminSettings />
                        </ChatProvider>
                    }
                />
                <Route
                    path="/manage-tags"
                    element={
                        <BusinessProtectedRoute>
                            <ManageTags />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/manage-therapists-advisors"
                    element={
                        <BusinessProtectedRoute>
                            <AdminProtectedRoute>
                                <ManageTherapistsAdvisors />
                            </AdminProtectedRoute>
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/ai-flow-manager"
                    element={
                        <BusinessProtectedRoute>
                            <AdminProtectedRoute>
                                <AiFlowManager />
                            </AdminProtectedRoute>
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/knowledge-base"
                    element={
                        <BusinessProtectedRoute>
                            <AdminProtectedRoute>
                                <KnowledgeBase />
                            </AdminProtectedRoute>
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/meeting-summary-search-test"
                    element={
                        <BusinessProtectedRoute>
                            <MeetingSummarySearchTest />
                        </BusinessProtectedRoute>
                    }
                />
                <Route
                    path="/meeting-feedback-search-test"
                    element={
                        <BusinessProtectedRoute>
                            <MeetingFeedbackSearchTest />
                        </BusinessProtectedRoute>
                    }
                />
            </Route>
            <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
    );
};

export default AppRouter;
